import React, { forwardRef } from 'react';
import { IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { faPlusCircle } from '@fortawesome/pro-light-svg-icons';

interface AddSeriesButtonProps {
  icon?: IconProp;
  onClick: () => void;
  className?: string;
  label?: string;
}

const AddSeriesButton = forwardRef<HTMLButtonElement, AddSeriesButtonProps>(
  ({ icon = faPlusCircle, onClick, label, className = '' }, ref) => {
    return (
      <IconButton className={`add-series-button ${className}`} onClick={onClick} ref={ref}>
        <FontAwesomeIcon icon={icon} className="icon" />
        <span>{label || 'Add Series'}</span>
      </IconButton>
    );
  },
);

AddSeriesButton.displayName = 'AddSeriesButton';

export default AddSeriesButton;
